import { BusinessEntity } from 'Models/Entities';
import useAsync from 'Hooks/useAsync';
import { RequestBusinessArgs, requestBusiness } from './requestBusiness';

/**
 * Hook for GQL api request to retrieve business entities viewable by the logged in user.
 */
export default function useGqlBusiness(args: RequestBusinessArgs) {
	const { filterByOrgId, filterByMonitor } = args;
	const request = useAsync(async (): Promise<BusinessEntity[] | undefined> => {
		try {
			const result = await requestBusiness(args);
			return result.data.businessEntitys.map(x => new BusinessEntity(x));
		} catch (e) {
			console.error(`Error fetching business entities:${e}`);
			return undefined;
		}
	}, [filterByOrgId, filterByMonitor]);
	return request;
}